import {useMemo, useRef} from "react";
import {useIsVisible} from 'react-is-visible';
import useElementSize from "@hooks/useElementSize";


const InViewRenderItem = ({children}) => {
    const nodeRef = useRef<any>()
    const isVisible = useIsVisible(nodeRef);
    const size = useElementSize(nodeRef);

    const height = useMemo(() =>  (size) ? Math.floor(size.height) : 0, [size]);
    const firstRender = useMemo(() => height > 0 ? false : true, [height]);

    const heightStyle = useMemo(() => {
        return isVisible || firstRender ? {} : { height: height };
    }, [isVisible, firstRender]);

    const hiddenStyle = useMemo(() => {
        return isVisible || firstRender ? {} : { display: "none" };
    }, [isVisible, firstRender]);

    return (
        <div ref={nodeRef} style={heightStyle}>
            <div style={hiddenStyle}>
                {children}
            </div>
        </div>
    );
};

export default InViewRenderItem;